import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../services/options.service'
import { setReasonsForFailureOptions } from '../store/options.actions'

export function* getReasonsForFailureOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const reasonsForFailureOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getReasonsForFailureOptions,
    ])
    const { entity } = reasonsForFailureOptionsResponse
    if (entity) yield put(setReasonsForFailureOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getReasonsForFailureOptions() error: ${e}`))
  }
}

export function* getReasonsForFailureOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getReasonsForFailureOptions)
}
